import { Component, OnInit, ViewChild, ElementRef, Input, QueryList, ContentChildren, AfterContentInit } from '@angular/core';
import { ProgressStepComponent } from '../progress-step/progress-step.component';

@Component({
  selector: 'app-step-progressbar',
  templateUrl: './step-progressbar.component.html',
  styleUrls: ['./step-progressbar.component.scss']
})
export class StepProgressbarComponent implements OnInit ,AfterContentInit {
  @ContentChildren(ProgressStepComponent) activeSteps!: QueryList<ProgressStepComponent>;
  @ViewChild('progress', { static: true }) progressRef!: ElementRef<HTMLDivElement>;
 @Input() steps: string[] = ['Select Vendor(s)', 'Confirm Selection', 'Send Request'];
    currentActive = 1;

  ngAfterContentInit(): void {
    this.update();
    this.updateSteps();
  }
  ngOnInit(): void {
  }
  onPrevClick(): void {
    this.currentActive = Math.max(1, this.currentActive - 1);
    this.update();
    this.updateSteps();
  }

  onNextClick(): void {
    this.currentActive = Math.min(this.steps.length, this.currentActive + 1);
    this.update();
    this.updateSteps();
  }

   update(): void {
    const progressWidth = ((this.currentActive - 1) / (this.steps.length - 1)) * 100;
    this.progressRef.nativeElement.style.width = `${progressWidth}%`;
  }
  @Input() public set selectedIndex(value: number) {
    this.currentActive = value || 1;
    this.updateSteps();
  }

  updateSteps(): void {
    if (!this.activeSteps || this.activeSteps.length === 0) {
      return;
    }
    this.progressSteps.forEach((step, index) => {
      step.activeState = this.activeStep;
      step.stepIndex = index + 1; 
    });
  }

  get activeStep(): ProgressStepComponent {
    return this.progressSteps[this.currentActive - 1];
  }

  private get progressSteps(): ProgressStepComponent[] {
    return this.activeSteps.toArray();
  }
}
